import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-component-help',
  templateUrl: './component-help.component.html',
  styleUrls: ['./component-help.component.scss']
})
export class ComponentHelpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
